// extracted by mini-css-extract-plugin
export default {"templateWrapper":"styles_templateWrapper__cgcL6","header":"styles_header__CuYCg","body":"styles_body__uI+fo","footer":"styles_footer__Ixho0"};